import React from "react";
import "react-vis/dist/style.css";
import { Breadcrumb, Row, Col, Tabs, Collapse, message } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

import DragUpload from "../Form/DragUpload";

const routes = [
  { path: "", breadcrumbName: "App" },
  { path: "/pnl", breadcrumbName: "P&L Cost Calculation" },
];

const Pnl = () => {
  const searchUploadSuccessHandler = (res) => {
    message.info(`Please check your 'System > Jobs' for the upload status.`);
  };

  return (
    <div>
      <div className="header">
        <Row>
          <Col span={12}>
            <h2 className="detail-header-text">P&L Cost Calculation</h2>
          </Col>
          <Col span={12}>
            <Breadcrumb
              style={{ margin: "10px 0", textAlign: "right" }}
              routes={routes}
            />
          </Col>
        </Row>
      </div>

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Pnl Cost Calculation" key="pnlSearch">
          <DragUpload
            action={`${process.env.REACT_APP_SERVER_URL}/api/pnl`}
            accept=".xls, .xlsx"
            method="post"
            onUploadSuccess={(res) => searchUploadSuccessHandler(res)}
            additionalDesc={`Excel file with "Tracking Number", "Cost Price", "Courier Weight", "Courier Pickup State" and "Courier Receiver State" columns.`}
          />
          <br />
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default Pnl;
